export const GET_DETAILS_PASSPORT_REQUEST = "GET_DETAILS_PASSPORT_REQUEST";
export const GET_DETAILS_PASSPORT_SUCCESS = "GET_DETAILS_PASSPORT_SUCCESS";
export const GET_DETAILS_PASSPORT_FAILURE = "GET_DETAILS_PASSPORT_FAILURE";

export const UPDATE_PASSPORT_REQUEST = "UPDATE_PASSPORT_REQUEST";
export const UPDATE_PASSPORT_SUCCESS = "UPDATE_PASSPORT_SUCCESS";
export const UPDATE_PASSPORT_FAILURE = "UPDATE_PASSPORT_FAILURE";
